import { Component, Input, AfterViewInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef, Inject } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort, SortDirection } from '@angular/material/sort';
import { BaseFilterComponent } from '../../shared/components/table-filters/base-filter.component';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { Subscription } from 'rxjs';
import { merge, of, Subject } from 'rxjs';
import { startWith, switchMap, map, catchError } from 'rxjs/operators';
import { TaskService } from '../../shared/services/task.service';
import { AuthService } from '../../auth/auth.service';
import { UserService } from '../../shared/services/user.service';
import { SearchRequest } from '../../shared/services/interfaces/search-request';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddCaseTaskComponent } from './add-case-task/add-case-task.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { OkPopupComponent } from 'src/app/shared/components/ok-popup/ok-popup.component';

@Component({
  selector: 'app-case-task-list',
  templateUrl: './case-task-list.component.html',
  styleUrls: ['./case-task-list.component.scss']
})
export class CaseTaskListComponent implements AfterViewInit {

  viewInit = false;
  @Input() caseId: number = -1;
  @Input() userType: string  = '';
  @Input() tasksFor: string = '';

  caseCompleted: boolean  = false;
  readOnly: boolean  = false;
  showCompleted: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);
  @ViewChild(MatSort) sort: MatSort = new MatSort();
  @ViewChildren('filter') filters: QueryList<BaseFilterComponent> = new QueryList<BaseFilterComponent>();

  data: any[] = [];
  isLoadingResults = true;
  resultsLength = 0;
  showAdd = true;
  faPlus = faPlus;
  staff: any[] = [];
  isMobile = false;
  listHeader: string = '';
  refreshSubscription?: Subscription;

  itemsSelected: any[] =[];

  changingValue: Subject<boolean> = new Subject();
  tellChild(allItemsSelected : any){
    this.changingValue.next(allItemsSelected);
  }

  userTaskMode: boolean = false;
  taskTableName: string = "";

  searchCriteria: SearchRequest = {page: 1, pageSize: 25, orderBy: "dueByDate", orderDirection: "asc", filterColumns: [], filterStrings: []};

  constructor(public activeModal: NgbActiveModal,
              private taskService: TaskService,
              public authService: AuthService,
              usersService: UserService,
              public modalService: ModalService) {


    usersService.staffLookup.subscribe((results : any) => {
      this.staff = results;
    });

    this.refreshSubscription = this.taskService.refreshTasksObservable.subscribe(() => {
      this.load();
    });
  }

  ngAfterViewInit(): void {
    this.viewInit = true;



    this.load();
   // this.taskService.refreshTasks.next();
  }

  load() {

    this.itemsSelected =[];

    if(!this.viewInit) return;

    this.listHeader = "Actions";

    const outputs = this.filters.map(button => button.filter);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => { this.paginator.pageIndex = 0 });
    merge(...outputs).subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, ...outputs)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

            let caseTasksSearchRequest: SearchRequest = {
              page: this.paginator.pageIndex + 1,
              pageSize: this.paginator.pageSize,
              orderBy: this.sort.active || 'dueByDate',
              orderDirection: this.sort.direction || 'asc',
              filterColumns: this.filters.map(button => button.filterColumn),
              filterStrings: this.filters.map(button => button.filterValue)
            };

            return this.taskService.caseTasks(this.caseId, caseTasksSearchRequest);
          
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.resultsLength = data.recordCount;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          return of([]);
        })
      ).subscribe(data => { this.data = data; });

  }

  isAllSelected() {

    const numSelected = this.itemsSelected.length;
    const numRows = this.data.length;
    return numSelected === numRows;
  }

  masterToggle(allSelected: any) {

    this.itemsSelected = [];
    this.tellChild(allSelected.checked);

    if(allSelected.checked){
      this.data.forEach(item => this.itemsSelected.push({ taskId: item.id, selected: true}));
    }
  }

  grabbingValues(val: any){

    if(val.selected)
      this.itemsSelected.push(val);
    else
    {
      this.itemsSelected = this.itemsSelected.filter(item => item.taskId !== val.taskId);
    }
  }

  ngOnDestroy() {

    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }


  addTask() {

    if(!this.caseCompleted)
    {

      const modalRef = this.modalService.openWithOptions(AddCaseTaskComponent, {size: 'md'});
          modalRef.componentInstance.caseId = this.caseId;
          modalRef.componentInstance.isNote = false;
          modalRef.componentInstance.taskId = null;
      
          modalRef.result.then(
            (result) => {
              if(result)
              {
                  this.load();
              }
          },
      () => {} // dismissed - do nothing
    );  
    }
    else if(this.caseCompleted){

      const modalRef = this.modalService.open(OkPopupComponent);
      modalRef.componentInstance.popupText1 ='Unable to add an Action as the case is Completed';

    }

  }

}
